export default __webpack_public_path__ + "static/media/Empty-profile.d0a126dc.svg";